import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import ReactObserver from "react-event-observer";

firebase.initializeApp({
  projectId: "thought-cabinet",
  apiKey: "AIzaSyBWNWb8K0PKLtNwEv5wAPR1wJQpkHHaGEI",
});

// Export Firestore instance
export default firebase;
// export const db = firebase.firestore();

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const firebaseObserver = ReactObserver();

export function loggedIn() {
  return !!auth.currentUser;
}
